<script>
import UserTile from '../../UserTile.vue';

export default {
  name: 'BaseTableProjectCell',
  components: { UserTile },
  props: {
    project: Object,
    isAuthor: Boolean,
  },
};
</script>

<template lang="pug">
.project
  UserTile.author(:user="project" :short="true")
  .project-details
    router-link(:to="{ name: 'project-stages', params: { projectId: project.id } }")
      .project-name {{ project.name }}
    .label.green(v-if="isAuthor") Мой проект
    .label.yellow(v-if="project.isReferralSample") Авторский проект
</template>

<style scoped lang="scss">
.project {
  display: flex;
  gap: 15px;
  align-items: center;
}
.project-details {
  display: flex;
  flex-direction: column;
  gap: 11px;
  align-items: flex-start;
}
.project-name {
  display: flex;
  flex-wrap: wrap;
  color: rgba(30, 49, 71, 1);
  font-family: 'Geometria', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  line-break: auto;
}
.label {
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.03em;
  color: #FFFFFF;
  border-radius: 4px;
  padding: 0 14px;
  box-sizing: border-box;
  height: 20px;

  &.green { background: #5AC169; }
  &.yellow { background: #F9D208; }
}
</style>
